import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import {
  Http,
  RequestOptions,
  Response,
  Headers,
  URLSearchParams
} from '@angular/http';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
declare const IN: any;

@Injectable()
export class AccountService {
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private params = new URLSearchParams();

  linkedInData;
  constructor(public http: Http, private httpClient: HttpClient) { }

  getSalutations() {
    const query: any = {};
    query.order = 'createdAt' + ' ' + 'ASC';
    const filter = new HttpParams().set('filter', JSON.stringify(query));
    return this.httpClient.get('Salutations', { params: filter });
  }

  getGeographies() {
    return this.httpClient.get('Geographies');
  }

  getIndustries() {
    const query: any = {};
    query.order = `industryName ASC`;
    const filter = new HttpParams().set('filter', JSON.stringify(query));
    return this.httpClient.get('Industries', {params: filter});
  }

  getJobTitles() {
    return this.httpClient.get('JobTitles');
  }

  getEmployeeSizes() {
    return this.httpClient.get('EmployeeSizes/getList');
  }

  getRevenues() {
    return this.httpClient.get('Revenues/getList');
  }

  getCountries() {
    const query: any = {};
    query.order = 'countryName' + ' ' + 'ASC';
    const filter = new HttpParams().set('filter', JSON.stringify(query));
    return this.httpClient.get('Countries', { params: filter });
  }

  getItBudgets() {
    return this.httpClient.get('ItBudgets/getList');
  }

  getLineOfBusinesses() {
    return this.httpClient.get('LineOfBusinesses');
  }

  registerUser(userFormData: object) {

    return this.httpClient.post('users', JSON.stringify(userFormData));
  }

  registerAnalyst(userFormData: object) {
    return this.httpClient.post(
      'AnalystRequests',
      JSON.stringify(userFormData)
    );
  }

  verifyUserByMobile(otp: string, email: string) {
    const params: HttpParams = new HttpParams()
      .set('otp', otp)
      .append('email', email);
    return this.httpClient.get('users/verify-otp', { params: params });
  }

  verifyUserByEmail(uid: string, token: string) {
    const params: HttpParams = new HttpParams().set('uid', uid);
    params.append('token', token);
    return this.httpClient.get('users/confirm', { params: params });
  }

  sendOtp(email: string, otpMethod: string, functionType: string) {
    const params = new HttpParams()
      .set('email', email)
      .append('type', otpMethod)
      .append('functionType', functionType);
    return this.httpClient.get('users/send-otp', { params: params });
  }

  verfiyPasswordResetOtp(otp: string, email: string) {
    const params: HttpParams = new HttpParams()
      .set('otp', otp)
      .append('email', email);
    return this.httpClient.get('users/verify-forgot-password-otp', {
      params: params
    });
  }

  resetPassword(accessToken: string, password: FormData) {
    const params: HttpParams = new HttpParams().set(
      'access_token',
      accessToken
    );
    // const headers: HttpHeaders = new HttpHeaders().set('Content-Type', 'multipart/form-data');
    return this.httpClient.post(
      'users/reset-password',
      JSON.stringify(password),
      { params: params }
    );
  }

  login(loginCredentials) {
    return this.httpClient.post('users/login', loginCredentials);
  }

  resendVerificationEmail(email: string) {
    const params = new HttpParams().set('emailId', email);
    return this.httpClient.get('users/resend-email', { params: params });
  }

  checkBlockListDomain(email, type) {
    return this.httpClient.get(`users/is-black-listed?type=${type}&email=${email}`);
  }

  getuserDetails(id: string, accessToken: string) {
    const query = {
      include: [
        'roles'
      ]
    };
    const filter = new HttpParams()
      .set('access_token', accessToken)
      .append('filter', JSON.stringify(query));
    return this.httpClient.get(`users/${id}`, { params: filter });
  }

  getOrganizationData(userId: string) {
    const params = new HttpParams().set('userId', userId);
    return this.httpClient.get('users/organization', { params: params });
  }
  getOrganizationsList() {
    const query: any = {};
    query.order = `name ASC`;
    const filter = new HttpParams().set('filter',JSON.stringify(query));
    return this.httpClient.get("Organizations", {params: filter});
  }

  async getLinkedIn(): Promise<any> {
    const sample = this;
    return await new Promise(resolve => {
      IN.User.authorize(() => {
        IN.API.Profile('me')
          // tslint:disable-next-line:max-line-length
          .fields(
            'id',
            'firstName',
            'headline',
            'location',
            'lastName',
            'num-connections',
            'picture-url',
            'date-of-birth',
            'emailAddress'
          )
          .result(data => {
            sample.linkedInData = data;
            resolve(data);
            this.logoutLinkedIn();
          });
      });
    });
  }

  private logoutLinkedIn() {
    IN.User.logout(() => {

    });
  }

  private extractData(res: Response) {
    const body = res.json();
    return body || {};
  }
  private handleError(error: any) {
    console.error('An error occurred', JSON.parse(error._body));
    return Promise.reject(JSON.parse(error._body).error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/external/account/shared/services/account.service.ts